import React, { useEffect, useMemo, useState } from 'react';
import { resolveWidgetRenderer } from '../renderer/widgetRenderer';
import { getWidgetType, isFilterWidget } from '../core/widgetTypes';
import { getMergedFilterParamsForWidget } from '../core/filterPropagation';

export default function ReportWidget({
  widget,
  allWidgets,
  adapter,
  mode,
  filterValuesByWidgetId,
  onFilterChange,
  isSelected,
  onSelect
}) {
  var widgetType = getWidgetType(widget);
  var WidgetRenderer = resolveWidgetRenderer(widgetType);
  var [loading, setLoading] = useState(false);
  var [error, setError] = useState('');
  var [rows, setRows] = useState([]);

  var mergedFilterParams = useMemo(function () {
    return getMergedFilterParamsForWidget(widget, allWidgets, filterValuesByWidgetId || {});
  }, [widget, allWidgets, filterValuesByWidgetId]);

  var mergedParams = useMemo(function () {
    return {
      ...(widget.parameterJson || {}),
      ...(widget.parameters || {}),
      ...mergedFilterParams
    };
  }, [widget, mergedFilterParams]);

  useEffect(
    function loadWidgetData() {
      var cancelled = false;

      async function load() {
        if (!adapter || isFilterWidget(widget)) {
          return;
        }

        try {
          setLoading(true);
          setError('');

          var raw;
          if (widget.procedureName) {
            console.log('rruning proc',widget.procedureName, mergedParams);
            console.log(raw);
            raw = await adapter.executeProcedure(widget.procedureName, mergedParams);
           
            raw = adapter.normalizeProcedureResult(raw);
          } else if (widget.sourceType === 'table' && widget.sourceName) {
            console.log('rruning proc',widget.procedureName, mergedParams);
            raw = await adapter.queryTable(widget.sourceName, mergedParams);            
            raw = adapter.normalizeProcedureResult(raw);
          } else {
            raw = Array.isArray(widget.rows) ? widget.rows : [];
          }

          if (!cancelled) {
            setRows(Array.isArray(raw) ? raw : []);
          }
        } catch (loadError) {
          if (!cancelled) {
            setError(loadError && loadError.message ? loadError.message : 'Failed loading widget data.');
            setRows([]);
          }
        } finally {
          if (!cancelled) {
            setLoading(false);
          }
        }
      }

      load();

      return function cleanup() {
        cancelled = true;
      };
    },
    [adapter, widget, mergedParams]
  );

  return (
    <div
      className={'re-widget-frame' + (isSelected ? ' re-widget-selected' : '')}
      onClick={function onClick() {
        if (onSelect) {
          onSelect(widget.id);
        }
      }}
      role="button"
      tabIndex={0}
      onKeyDown={function onKeyDown(event) {
        if (event.key === 'Enter' && onSelect) {
          onSelect(widget.id);
        }
      }}
    >
      <div className="re-widget-header">
        <div>
          <div className="re-widget-title">{widget.headerLabel || widget.data.headerLabel || ''}</div>
          {(widget.subHeaderLabel || widget.data.subHeaderLabel) && (
            <div className="re-widget-subtitle">{widget.subHeaderLabel || widget.data.subHeaderLabel}</div>
          )}
        </div>
        {widget.icon ? <div className="re-widget-icon">{widget.icon}</div> : null}
      </div>

      <div className="re-widget-body">
        <WidgetRenderer
          widget={widget}
          rows={rows}
          loading={loading}
          error={error}
          mode={mode}
          adapter={adapter}
          mergedParams={mergedParams}
          mergedFilterParams={mergedFilterParams}
          onFilterChange={function nextFilterValue(value) {
            if (!onFilterChange || !widget.filterName) {
              return;
            }

            onFilterChange(widget.id, {
              [widget.filterName]: value
            });
          }}
          setFilterParam={function setFilterParam(filterName, value) {
            if (!onFilterChange || !filterName) {
              return;
            }

            onFilterChange(widget.id, {
              [filterName]: value
            });
          }}
        />
      </div>
    </div>
  );
}
